import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import AutocompleteInput from '../../libs/AutocompleteInput';
import { handleStateChangeFromProps } from '../../libs/helpers';
import TextareaInput from '../../libs/TextareaInput';
import TextInput from '../../libs/TextInput';

class InstitutionRecipientInfo extends React.Component {
  state = {
    form: {},
    errors: {},
    onChange: null,
  }
  /*
 -----------------------------------------------------------------------
 RENDER Functions
 -----------------------------------------------------------------------
 */
  static getDerivedStateFromProps(nextProps, prevState) {
    return handleStateChangeFromProps(nextProps, prevState)
  }
  render() {
    const { errors, form } = this.state;
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Institution Information
        </Typography>
        <Typography variant="subtitle1">
        </Typography>
        <Grid container spacing={3}>
          <TextInput
            width={12}
            value={form.recipient_account_number}
            error={errors.recipient_account_number}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_account_number'
            description='between 10 and 12 characters'
            title='Institution Account Number (NOT IBAN)'
          />
          <TextInput
            width={6}
            value={form.recipient_name}
            error={errors.recipient_name}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_name'
            title='Institution Name'
          />
          <TextInput
            width={6}
            value={form.recipient_nickname}
            error={errors.recipient_nickname}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_nickname'
            title='Institution Nickname'
          />
          <AutocompleteInput
            width={6}
            value={form.recipient_country_id}
            onChange={this.props.onChange}
            name='recipient_country_id'
            title='Institution Country'
            error={errors.recipient_country_id}
            enabled={errors.enabled}
            data='countries'
          />

          <TextInput
            width={6}
            value={form.recipient_region}
            error={errors.recipient_region}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_region'
            title='Institution Region'
          />
          <TextInput
            width={6}
            value={form.recipient_city}
            error={errors.recipient_city}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_city'
            title='Institution City'
          />
          <TextInput
            width={6}
            value={form.recipient_address}
            error={errors.recipient_address}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_address'
            title='Institution Address'
          />


          <TextInput
            width={6}
            value={form.recipient_postal_code}
            error={errors.recipient_postal_code}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_postal_code'
            title='Institution Postal Code'
          />
          <TextInput
            width={6}
            value={form.recipient_phone_number}
            error={errors.recipient_phone_number}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='recipient_phone_number'
            title='Institution Phone Number'
          />
          <TextareaInput
            width={12}
            value={form.message_to_recipient_bank}
            error={errors.message_to_recipient_bank}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='message_to_recipient_bank'
            title='Message to Bank (Template)'
          />
          <TextareaInput
            width={12}
            value={form.message_to_recipient}
            error={errors.message_to_recipient}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='message_to_recipient'
            title='Message to Institution (Template)'
          />

        </Grid>
      </React.Fragment>
    );
  }
}

export default InstitutionRecipientInfo;